import hero1 from 'assets/Images/hero_1_layout.svg'
import hero2 from 'assets/Images/hero_2_layout.svg'
import hero3 from 'assets/Images/hero_3_layout.svg'
import hero4 from 'assets/Images/hero_4_layout.svg'
import hero5 from 'assets/Images/hero_5_layout.svg'
import hero6 from 'assets/Images/hero_6_layout.svg'
import hero7 from 'assets/Images/hero_7_layout.svg'
import hero8 from 'assets/Images/hero_8_layout.svg'
import hero9 from 'assets/Images/hero_9_layout.svg'
export const staticImgs = [
  hero1,
  hero2,
  hero3,
  hero4,
  hero5,
  hero6,
  hero7,
  hero8,
  hero9,
]

export const carouselContent = [
  {
    id: 1,
    content: {
      headingBefore: '',
      headingColored: 'FALL SOCCER',
      headingAfter: 'IS ALMOST HERE',
      // headingImg: "/assets/hero_text_1.png",
      description:
        "Get ready for an action-packed season of skill-building, teamwork, and unforgettable moments on the field. BRAL’s Fall Soccer League is just around the corner, and whether you're a returning athlete or new to the game, this is your chance to be part of something special. Signups aren’t open yet, but our mailing list gets first access. Join now to stay in the loop on registration dates, program details, and exclusive updates. Don’t miss your shot—sign up for the newsletter today and be game-day ready!",
      buttonText: 'Sign up',
      buttonLink: 'athletics/programs/program-detail/fall-soccer/',
    },
    card: {
      type: 'none',
      videoUrl: 'https://www.youtube.com/embed/DC2p3kFjcK0?si=v2ty2U7LoGBgwYaM',
    },
    gallery: ['', '', '', '', '', '', '', '', ''],
  },
  {
    id: 2,
    content: {
      headingBefore: 'Winter',
      headingColored: 'Camp',
      headingAfter: 'Is coming out soon',
      // headingImg: "/assets/hero_text_2.png",
      description:
        'Our Fall quarter is shaping up to be a blast! Check out all the upcoming events for some fun Bamrec style!',
      buttonText: 'Early bird tickets',
      buttonLink: '/spaces',
    },
    card: {
      type: 'event',
      event: {
        name: 'Bamrec Winter Camp',
        coverPhoto: '/assets/cardimg.png',
        startDate: '2022-12-01',
        endDate: '2022-12-02',
        venueType: 'physical',
        location: {
          street: '314',
          city: 'Los angles',
          state: 'california',
          country: 'USA',
        },
      },
    },
    gallery: [
      '/assets/cardimg.png',
      '/assets/hero_gal_1_2.png',
      '/assets/hero_gal_1_3.png',
      '/assets/hero_gal_1_4.png',
      '/assets/hero_gal_1_5.png',
      '/assets/hero_gal_1_6.png',
      '/assets/hero_gal_1_7.png',
      '/assets/hero_gal_1_8.png',
      '/assets/hero_gal_1_9.png',
    ],
  },
  {
    id: 3,
    content: {
      headingBefore: 'Find your',
      headingColored: 'mentor',
      headingAfter: '',
      // headingImg: "/assets/hero_text_3.png",
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      buttonText: 'Request a mentor',
      buttonLink: '/',
    },
    card: {
      type: 'none',
    },
    gallery: [
      '/assets/cardimg.png',
      '',
      '/assets/hero_gal_1_3.png',
      '/assets/hero_gal_1_4.png',
      '/assets/hero_gal_1_5.png',
      '/assets/hero_gal_1_6.png',
      '/assets/hero_gal_1_7.png',
      '/assets/hero_gal_1_8.png',
      '/assets/hero_gal_1_9.png',
    ],
  },
]
